export default "__VITE_ASSET__BXIFgZ_n__"